import moment from "moment"

const defaultSearchParams = {
  orderDateFrom: "",
  orderDateTo: "",
  customerName: "",
  page: 0,
  size: 10,
  sort: "asc", // asc || desc
}

const productTableItem = {
  productNumber: "",
  productName: "",
  unitPrice: 0,
  number: 0,
  discount: 0,
  inputDiscount: 0,
  totalAmount: 0,
  discountType: "%",
}
const defaultProductTableData = Array(7).fill(productTableItem)

const defaultProductDetail = {
  // id: 0,
  productId: 0,
  size: 0,
  number: 0,
  discountType: "%",
  discount: 0,
  amount: 0,
}
const defaultPayment = {
  // id: 0,
  paymentMethodId: 0,
  paymentDate: "2023-04-01",
  amount: 0,
}
const defaultPayload = {
  orderDate: moment(new Date()).format("YYYY-MM-DD"),
  customerId: 0,
  customerName: "",
  guest: false,
  details: Array(7).fill(defaultProductDetail),
  payments: [],
}

const discountOptions = [
  {
    label: "%",
    value: "percentage",
  },
  {
    label: "円",
    value: "amount",
  },
]

export {
  defaultSearchParams,
  defaultPayload,
  defaultPayment,
  defaultProductDetail,
  discountOptions,
  defaultProductTableData,
  productTableItem,
}
